import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const textFieldClasses = generateUtilityClasses('AFTextField', [
  'textFieldContainer',
  'textFieldLabel',
  'helperMessage',
  'errorIcon',
  'clearIcon',
  'counterContainer',
  'counter',
  'footer',
  'helpIcon'
]);
